export const REQUIRED_OPEN_DAYS = 7;

// The fruits live in the spin wheel items collection. This list is only a
// fallback for a record that arrives without one.
export const SPIN_WHEEL_FRUITS = ['Banana', 'Orange', 'Mango', 'Melon', 'Strawberry', 'Pineapple'];

const padDatePart = (value) => String(value).padStart(2, '0');

export const getLocalDateKey = (date = new Date()) =>
  `${date.getFullYear()}-${padDatePart(date.getMonth() + 1)}-${padDatePart(date.getDate())}`;

const normalizeOpenDaysCount = (openDaysCount) => {
  const count = Number(openDaysCount);

  if (!Number.isFinite(count) || count < 0) {
    return 0;
  }

  return Math.min(Math.floor(count), REQUIRED_OPEN_DAYS);
};

const normalizeSpinsAvailable = (spinsAvailable) => {
  const count = Number(spinsAvailable);

  if (!Number.isFinite(count) || count < 0) {
    return 0;
  }

  return Math.floor(count);
};

// Names are kept as stored: which of them still count as fruits depends on the
// wheel that is configured in the database, so that check happens on the page.
const normalizeCollectedFruits = (fruits) => {
  if (!Array.isArray(fruits)) {
    return [];
  }

  return [...new Set(fruits)].filter((fruit) => typeof fruit === 'string' && fruit.trim().length > 0);
};

export const createDefaultSpinWheelProgress = (sessionId, today = getLocalDateKey()) => ({
  session_id: sessionId,
  last_counted_open_date: today,
  open_days_count: 1,
  spins_available: 0,
  last_spin_at: null,
  fruits: SPIN_WHEEL_FRUITS,
  collected_fruits: [],
});

/**
 * Shapes a progress record from the API for the page. Visits, spins and the
 * basket are all decided on the server; this only guards against a malformed
 * payload and never grants a spin the server did not.
 */
export const normalizeSpinWheelProgress = (progress, sessionId) => ({
  session_id: progress?.session_id || sessionId,
  last_counted_open_date: progress?.last_counted_open_date || null,
  open_days_count: normalizeOpenDaysCount(progress?.open_days_count),
  spins_available: normalizeSpinsAvailable(progress?.spins_available),
  last_spin_at: progress?.last_spin_at || null,
  fruits: Array.isArray(progress?.fruits) && progress.fruits.length > 0 ? progress.fruits : SPIN_WHEEL_FRUITS,
  collected_fruits: normalizeCollectedFruits(progress?.collected_fruits),
});

export const getRemainingOpenDays = (progress) =>
  Math.max(REQUIRED_OPEN_DAYS - normalizeOpenDaysCount(progress?.open_days_count), 0);

export const isSpinWheelEligible = (progress) => normalizeSpinsAvailable(progress?.spins_available) > 0;
